import * as React from 'react';
// ModalInfo is intentionally imported directly — the molecules barrel export
// of it causes a white-screen crash (see ui-react/CLAUDE.md).
import ModalInfo from './ModalInfo';

interface InactiveContactRecord {
  contactIsActive?: boolean | null;
  contactFirstName?: string;
  contactLastName?: string;
  companyName?: string;
  parentCompany?: string;
  contactEmail?: string;
}

interface Props {
  /** The record being opened (activity / inspection / ticket / condition). */
  record?: InactiveContactRecord | null;
}

/**
 * Warns staff that the contact assigned to an activity / inspection / ticket /
 * condition is no longer available (the contact user or its company has been
 * deactivated). Renders nothing unless the backend flagged the record's contact
 * as inactive (`contactIsActive === false`). Warn-only: it does not block the
 * underlying edit form, so staff can dismiss it and reassign the contact.
 */
const ContactNotAvailableModal = ({ record }: Props) => {
  const [open, setOpen] = React.useState(true);

  if (!record || record.contactIsActive !== false || !open) {
    return null;
  }

  const name =
    [record.contactFirstName, record.contactLastName]
      .filter(Boolean)
      .join(' ') ||
    record.companyName ||
    record.parentCompany ||
    'This contact';

  const nameWithEmail = [name, record.contactEmail]
    .filter(Boolean)
    .join(' - ');

  const message = `"${nameWithEmail}" is not available and must be changed to an individual before proceeding. Companies cannot be added directly to activities.`;

  return (
    <ModalInfo
      isError
      title="Contact Not Available"
      message={message}
      timeToClose={0}
      onClose={() => setOpen(false)}
    />
  );
};

export default ContactNotAvailableModal;
